<!--
 * @Description: 表格组件，默认宽度150px
 * @Author: 琢磨先生
 * @Date: 2024-08-15 10:26:59
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2024-10-12 09:35:04
-->
<template>
	<el-table-column
		:label="item.label"
		:prop="item.prop"
		:resizable="item.resizable ? true : false"
		:sortable="item.sortable"
		:width="item.minWidth ? 0 : item.width ? item.width : '150'"
		:min-width="item.minWidth"
		:fixed="item.fixed"
		:show-overflow-tooltip="item.tooltip"
		:align="item.align?item.align:'center'"
	>
		<template #default="{ row }">
			<slot :name="item.prop" :row="row" :item="item">
				<div v-if="item.prop === 'batch_no'">
					<dc-info-image
						v-if="item.type === 'image'"
						:batch-no="row[item.prop]"
						:group="item.group"
						:key="row['updated_at']"
					></dc-info-image>
					<dc-info-file
						v-if="item.type === 'file'"
						:batch-no="row[item.prop]"
						:group="item.group"
						:key="row['updated_at']"
					></dc-info-file>
				</div>
				<div v-else-if="item.type === 'image'">
					<slot name="image" :slotProps="row"></slot>

					<!-- <el-image
						style="width: 60px; height: 60px"
						:src="row[item.prop]"
						:zoom-rate="1.2"
						:max-scale="7"
						:min-scale="0.2"
						:preview-src-list="[row[item.prop]]"
						:initial-index="0"
						fit="cover"
						:preview-teleported="true"
					/> -->
					<!-- 图片预览 -->
				</div>
				<!-- <div v-else-if="item.type === 'switch'">
					<el-tag v-if="row[item.prop] === 1" type="success">是</el-tag>
					<el-tag v-if="row[item.prop] === 0" type="danger">否</el-tag>
				</div> -->
				<div v-else-if="item.type === 'select' && !item['multiple']">
					<template v-for="tag in item.options" :key="tag">
						<el-link
							underline="never"
							v-if="tag.value === row[item.prop] && tag.type"
							:type="tag.type"
							>{{ tag.label }}</el-link
						>
						<el-popconfirm
							@confirm="entryWorkplace(row)"
							:title="`确定入职【${row.name}】？`"
							width="220"
							v-if="item.isShow ? (item.isShow == 1 ? false : true) : true"
						>
							<template #reference>
								<!-- 候选人专用 -->
								<span>
									<el-button
										link
										type="primary"
										size="small"
										v-if="
											tag.value === row[item.prop] &&
											row[item.prop] == 25 &&
											(row['flow_status'] == 0 || row['flow_status'] == 30)
										"
										>入 职</el-button
									>
								</span>
							</template>
						</el-popconfirm>
						<!-- <el-button link type="primary" size="small" @click="entryWorkplace(row)" v-if="tag.value === row[item.prop] && row[item.prop] == 25">入职</el-button> -->

						<span v-if="tag.value === row[item.prop] && !tag.type">{{ tag.label }}</span>
					</template>
				</div>
				<div v-else-if="item.type === 'radio'">
					<template v-for="tag in item.options" :key="tag">
						<el-tag v-if="tag.value === row[item.prop] && tag.type" :type="tag.type">{{
							tag.label
						}}</el-tag>
						<span v-if="tag.value === row[item.prop] && !tag.type">{{ tag.label }}</span>
					</template>
				</div>
				<div v-else-if="item.type == 'pingjie'">{{ row.grade_code }}{{ row.grade_level }}</div>
				<template v-else>
					{{ handleView(row) }}
				</template>
			</slot>
		</template>
	</el-table-column>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
	item: {
		type: Object,
		required: true,
		default: {}
	}
})

const emit = defineEmits(['entryWorkplace'])

const entryWorkplace = (val) => {
	emit('entryWorkplace', val)
}

function handleView(row) {
	if (!props.item.prop) {
		return ''
	}
	if (row[props.item.prop] == '' || row[props.item.prop] == null) {
		return '-'
	}
	if (
		(props.item.type === 'select' || props.item.type === 'radio') &&
		props.item.options &&
		Array.isArray(props.item.options)
	) {
		if (props.item['multiple'] === true) {
		} else {
			return props.item.options.find((item) => item.value === row[props.item.prop])?.label
		}
	}
	if (props.item.type === 'checkbox' && props.item.option) {
		return row[props.item.prop] === props.item.option.trueValue
			? props.item.option.trueLabel
			: props.item.option.falseLabel
	}
	return row[props.item.prop]
}
</script>

<style lang="scss"></style>
